import React, { useMemo } from "react";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import Fade from "@material-ui/core/Fade";
import Slide from "@material-ui/core/Slide";
import Grow from "@material-ui/core/Grow";
import {
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
} from "@material-ui/core";
import { ChatAvatar } from "../../../../digitalArena/modules/ChatModule/components/ChatAvatar";
import { combineProps } from "../../../../helpers/objectHelper";
import { formatTime } from "../../../../helpers/time.helper";
import { LinkedInButton } from "../../../shared/LinkedInButton";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";

function SlideTransition(props) {
  return <Slide {...props} direction="up" />;
}

export default function NotificationSnackbar(props) {
  const {
    chat,
    page,
    clientKey,
    orderList,
    connectionList,
    selectChat,
  } = props;

  const unreadTargets = useMemo(() => {
    if (page == "CHAT") return;
    const targetList = [];
    chat.map((c) => {
      const undreadMessages = c.messages.filter(
        (c) => c.receiver == clientKey && c.seen == false
      ).length;


      if (undreadMessages > 0) {
        const target = orderList.find((o) => o.badgeNo == c.target);

        const lastMessage = c.messages[c.messages.length - 1].message;

        targetList.push({
          target,
          undreadMessages,
          lastChange: formatTime(c.lastChange),
          lastMessage: `${lastMessage?.substring(0, 20)} • `,
        });
      }
    });
    return targetList;
  }, [page, chat]);


  return unreadTargets
    ? unreadTargets.map((u, i) => {
      if (!u.target) return null;
      return (
        <div
          className={`chat-snackbar`}
          style={{ bottom: `calc(15px + ${i * 85}px)` }}
          key={i}
        >
          <ListItem>
            <ListItemAvatar>
              {/*        {isHost ? <VerifiedUserIcon className="expo-admin-icon" /> : null} */}
              <ChatAvatar
                {...combineProps([
                  props,
                  {
                    connectionList,
                    orderList,
                    primaryColor: "#e4e6eb",
                    secondaryColor: "#fff",
                    border: "1px solid #eee",
                    target: u.target.badgeNo,
                  },
                ])}
              ></ChatAvatar>
            </ListItemAvatar>

            <ListItemText
              primary={
                <div style={{ display: "flex", maxWidth: 140 }}>
                  <span
                    className="ellipsis"
                    style={{ fontWeight: "600", fontSize: "1rem" }}
                  >
                    {u.target.name}
                  </span>
                  <div className="notice-dot-expo-new">
                    {u.undreadMessages}
                  </div>
                </div>
              }
              secondary={
                <span
                  style={{
                    fontSize: "1rem",
                  }}
                >
                  {u.lastMessage}
                  {u.lastChange}
                </span>
              }
            />
            <ListItemSecondaryAction>
              <Button onClick={() => selectChat(u.target.badgeNo)}>
                <SystemLabel name="Read" />
              </Button>
              {/*     <LinkedInButton {...v} /> */}
              {/*      <IconButton onClick={() => selectChat(v.badgeNo)}>
            <ChatBubbleIcon />
          </IconButton> */}
            </ListItemSecondaryAction>
          </ListItem>
        </div>
      );
    })
    : null;
}
